module.exports = __webpack_public_path__ + "img/lihansk_people_s_republic.1c3f8b7.webp";